import React from 'react';

import {
  TableChart,
} from '../../components/Statistics';

const SORTS = {
  default: {
    id: 'default',
    label: 'Default Sort',
    // sort: items => items,
    sort: items => [...items].sort((a, b) => (
        a.defaultSortIndex > b.defaultSortIndex ? 1
      : a.defaultSortIndex < b.defaultSortIndex ? -1
      : (
            !a.label?.length && !b.label?.length ? 0
          : !a.label?.length ? 1
          : !b.label?.length ? -1
          : 0
        )
    )),
  },
  valueAsc: {
    id: 'valueAsc',
    label: 'Lowest First',
    sort: items => [...items].sort((a, b) => (
        a.value > b.value ? 1
      : a.value < b.value ? -1
      : (
            !a.label?.length && !b.label?.length ? 0
          : !a.label?.length ? 1
          : !b.label?.length ? -1
          : a.label > b.label ? 1
          : a.label < b.label ? -1
          : 0
        )
    )),
  },
  valueDsc: {
    id: 'valueDsc',
    label: 'Highest First',
    sort: items => [...items].sort((a, b) => (
        a.value > b.value ? -1
      : a.value < b.value ? 1
      : (
            !a.label?.length && !b.label?.length ? 0
          : !a.label?.length ? 1
          : !b.label?.length ? -1
          : a.label > b.label ? 1
          : a.label < b.label ? -1
          : 0
        )
    )),
  },
};

function renderChart(
  data,
  chart,
  group,
  compared,
  comparedReversed,
  view,
  pageProps,
) {
  return (
    <TableChart
      data={data}
      title={group.title}
      skipEmpty={group.skipEmpty}
      percentage={group.percentage}
      precision={chart.precision}
      view={view}
      compared={compared}
      comparedReversed={comparedReversed}
      maxItems={group.maxItems}
      pageProps={pageProps}
    />
  );
}

export default function createChartGroup(group) {
  group.sorts = group.sorts || ['default'];
  group.sortsMap = {};
  if (group.sorts) {
    group.sorts = group.sorts.map((sort) => {
      if (SORTS[sort]) {
        return SORTS[sort];
      }
      return SORTS.default;
    });
    group.sortsMap = group.sorts.reduce(
      (agr, sort) => {
        agr[sort.id] = sort;
        return agr;
      },
      {},
    );
  }
  group.chartsMap = group.charts.reduce(
    (agr, chart) => {
      chart.renderChart = chart.renderChart || renderChart;
      agr[chart.id] = chart;
      return agr;
    },
    {},
  );
  return group;
}
